export const DATE_FORMAT_DB = 'yyyy-MM-dd'
export const DATE_FORMAT_INT = 'yyMMdd'
export const DATE_FORMAT_VIEW = 'MM/dd/yyyy'
export const DATE_FORMAT_VIEW_LONG = 'MMM dd, yyyy, hh:mm a'
export const DATE_FORMAT_SCATTER_PLOT = '%m/%d/%Y'
export const LINK_COLUMN_NAME = 'link'
